import React, { ReactNode } from 'react';
import { Card } from '../../Layout/Card';
import { Icons } from '../../Icons/Icons';
import { CheckableText } from './CheckableText';
import { GLStep } from '../../../../../ViewModel/TutorialStateViewModel';
import { TutorialFlyout } from '../../TutorialFlyout';

export type style = 'none' | 'line-through';
export type CheckableTextData = {
    key: string,
    text: string,
    checked: boolean,
    onItemChecked: () => void;
};

interface CompletableTextProps {
    title: string;
    entries: CheckableTextData[];
    headerIcon?: ReactNode;
    style?: style;
    className?: string;
    tutorialSteps?: GLStep[];
}


export const CheckableTextGroup: React.FC<CompletableTextProps> = ({ entries, title, headerIcon, style, className, tutorialSteps }) => {

    const header = headerIcon ? headerIcon : <Icons.CardBulletIcon className='gl-group-header-icon' />;

    return (
        <div className={`gl-list CompletableTextGroup ${className ?? ''}`}>
            {entries.length > 0 && <>

                <Card noMargin disableClick>
                    <TutorialFlyout steps={tutorialSteps}>
                        <div className='flex flex-row justify-content-start align-items-center mb-3'>
                            {header}
                            <p className='gl-list-header-spacing gl-content-header-typography'>{title}</p>
                        </div>
                    </TutorialFlyout>
                    {
                        entries.map((entry, index) => (
                            entry.text.length > 0 &&
                            <CheckableText
                                style={style}
                                key={entry.key}
                                number={index + 1}
                                data={entry}
                            />
                        ))
                    }

                </Card >
            </>
            }
        </div>
    );
};